import api from './api';

export interface CategoryValue {
    categoryValueId: number;
    categoryValueName: string;
    parentId?: number;
    appliesOnline?: number;
    catName?: string;
    description?: string;
    sortOrder?: number;
    syncTs?: number;
    catStatus?: string;
    lovSequence?: number;
    isTopRated?: boolean;
    id?: string;
}

export interface Category {
    id?: string;
    catName: string;
    displayName?: string;
    Status?: string;
    imageUrl?: string;
    categoryValues?: CategoryValue[];
    createdAt?: string;
    updatedAt?: string;
}

export interface CategoryListData {
    items: Category[];
    pagination?: {
        currentPage: number;
        totalPages: number;
        totalItems: number;
        itemsPerPage: number;
    };
}

export interface CategoryResponse {
    success: boolean;
    message?: string;
    data?: CategoryListData | Category[];
}

export interface SyncResponse {
    success: boolean;
    message?: string;
    data?: {
        synced: number;
        categories?: Category[];
    };
}

// Sync categories from external source
// Using same api instance - proxy will handle the routing
export const syncCategories = async (): Promise<SyncResponse> => {
    const response = await api.post('/category/sync');
    return response.data;
};

// Get all categories with pagination and search
export const getCategories = async (params?: { page?: number; limit?: number; search?: string }): Promise<CategoryResponse> => {
    const response = await api.get('/category', { params });
    return response.data;
};

// Get single category by ID
export const getCategoryById = async (id: string): Promise<{ success: boolean; data?: Category }> => {
    const response = await api.get(`/category/${id}`);
    return response.data;
};

// Update category - PATCH /api/site/category/:id
export interface UpdateCategoryPayload {
    displayName?: string;
    Status?: string;
    catName?: string;
}

export const updateCategory = async (
    id: string,
    payload: UpdateCategoryPayload
): Promise<{ success: boolean; message?: string; data?: Category }> => {
    const response = await api.patch(`/category/${id}`, payload);
    return response.data;
};

// Upload category icon/image - PUT /api/site/category/:id/upload
export const uploadCategoryImage = async (id: string, file: File): Promise<{ success: boolean; message?: string; data?: { imageUrl?: string } }> => {
    const formData = new FormData();
    formData.append('image', file, file.name);
    const response = await api.put(`/category/${id}/upload`, formData);
    return response.data;
};

// Get sync status
export const getSyncStatus = async (): Promise<{
    success: boolean;
    data: {
        isRunning: boolean;
        progress: {
            totalPages: number;
            processedPages: number;
            totalFetched: number;
            created: number;
            updated: number;
            failed: number;
        };
        lastError?: string;
    }
}> => {
    const response = await api.get('/category/sync/status');
    return response.data;
};
